module.exports = __webpack_public_path__ + "img/101-06.prt.a0df61b8.jpg";